import React, { Component } from "react";
// nodejs library that concatenates strings
import { Link, NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import NavbarLogo from "../assets/img/dark & blue.svg";

class NavbarComponent extends Component {
  componentDidMount() {
    window.addEventListener("scroll", this.resizeHeaderOnScroll);
  }
  resizeHeaderOnScroll() {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop,
      shrinkOn = 10,
      nav = document.getElementById("navbar-head");

    if (distanceY > shrinkOn) {
      nav.classList.add("bg-light");
    } else {
      nav.classList.remove("bg-light");
    }
  }
  render() {
    return (
      <Navbar
        collapseOnSelect
        expand="lg"
        sticky="top"
        variant="light"
        id="navbar-head"
      >
        <div className="container">
          <Link to="/">
            {" "}
            <Navbar.Brand>
              <img src={NavbarLogo} alt="Curigma"></img>
            </Navbar.Brand>
          </Link>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Link as={NavLink} to="/about">
                <b>About us</b>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/service">
                <b>Services</b>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/product">
                <b>Product</b>
              </Nav.Link>
              <Nav.Link as={NavLink} to="/contact">
                <b>Contact</b>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    );
  }
}

export default NavbarComponent;
